import PlanningTool from 'modules/project_management/components/PlanningTool'

const PlanningToolSchedule = () => {
  return <PlanningTool />
}

export default PlanningToolSchedule
